import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "configurations" }
const _hoisted_2 = ["options", "values", "label", "placeholder", "disabled", "isLoading"]
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = ["options", "values", "label", "placeholder", "disabled", "isLoading"]
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { ListResourceRequestParams, ResourceQueryOptions } from '../../models/resource/ui-types';
import { useServices } from '../../queries/useServiceQueries';
import { useConfigurations } from '../../queries/useConfigurationQueries';
import { debounce } from 'lodash';
import { AppFormBindings } from 'models/application/ui-types';

interface Props {
  bindings: AppFormBindings;
  namespace: string;
  mode: string;
  active: boolean;
  updateBindings: (newBindings: Partial<AppFormBindings>) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppConfiguration',
  props: {
    bindings: {},
    namespace: {},
    mode: {},
    active: { type: Boolean },
    updateBindings: { type: Function }
  },
  setup(__props: any) {


const props = __props;
  
const store = useStore();

const t = store.getters['i18n/t'];

watch(() => props.namespace, (newNamespace) => {
  requestParams.value.namespaces = newNamespace ? [newNamespace] : [];
  requestOptions.value.enabled = !!newNamespace;
});

const requestParams = ref<ListResourceRequestParams>({
  page: 1,
  pageSize: 10,
  search: '',
});
const requestOptions = ref<ResourceQueryOptions>({
  enabled: false,
  polling: false,
});
const {data: fetchedServices, isLoading: isLoadingServices, isError: isErrorServices} = useServices(store, requestParams, requestOptions);
const {data: fetchedConfigurations, isLoading: isLoadingConfigurations, isError: isErrorConfigurations} = useConfigurations(store, requestParams, requestOptions);

const onServicesFilter = debounce((query: string) => {
  requestParams.value.page = 1;
  requestParams.value.search = query;
}, 500);

const onConfigurationsFilter = debounce((query: string) => {
  requestParams.value.page = 1;
  requestParams.value.search = query;
}, 500);

const hasConfigs = computed(() => fetchedConfigurations.value?.items ? fetchedConfigurations.value?.items?.length > 0 : false);
const noConfigs = computed(() => !hasConfigs.value);
const hasServices = computed(() => fetchedServices.value?.items ? fetchedServices.value?.items?.length > 0 : false);
const noServices = computed(() => !hasServices.value);

const configurations = computed(() => {
  if (!fetchedConfigurations.value?.items?.length) {
    return [];
  }
  const list = fetchedConfigurations.value?.items
    .filter((c) => { return c.configuration.type !== 'service'; })
    .map((c) => ({ 
      label: c.meta.name,
      value: c.meta.name,
    }));

    return list;
});

const services = computed(() => {
  if (!fetchedServices.value?.items?.length) {
    return [];
  }
  const list = fetchedServices.value?.items.map((s) => ({
    label: `${s.meta.name} (${s.catalogService})`,
    value: `${props.namespace}/${s.meta.name}`,
  }));

  return list;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("trailhand-dropdown", {
        style: {"width":"100%"},
        options: configurations.value,
        values: _ctx.bindings.configurations,
        label: _unref(t)('typeLabel.configurations', { count: 2}),
        placeholder: noConfigs.value ? _unref(t)('epinio.applications.steps.configurations.configurations.select.placeholderNoOptions') : _unref(t)('epinio.applications.steps.configurations.configurations.select.placeholderWithOptions'),
        disabled: noConfigs.value,
        filterable: "",
        multiselect: "",
        isLoading: _unref(isLoadingConfigurations),
        onDropdownChange: _cache[0] || (_cache[0] = (e) => { 
          _ctx.updateBindings({ configurations: e.detail.values });
        }),
        onDropdownFilter: _cache[1] || (_cache[1] = (e) => { _unref(onConfigurationsFilter)(e.detail.filter); })
      }, null, 40, _hoisted_2),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (_unref(isErrorConfigurations))
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)(`epinio.configurations.errors.fetchAll`)), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", null, [
      _createElementVNode("trailhand-dropdown", {
        style: {"width":"100%"},
        options: services.value,
        values: _ctx.bindings.services.map((s) => `${_ctx.namespace}/${s}`),
        label: _unref(t)('typeLabel.services', { count: 2}),
        placeholder: noServices.value ? _unref(t)('epinio.applications.steps.configurations.services.select.placeholderNoOptions') : _unref(t)('epinio.applications.steps.configurations.services.select.placeholderWithOptions'),
        disabled: noServices.value,
        filterable: "",
        multiselect: "",
        isLoading: _unref(isLoadingServices),
        onDropdownChange: _cache[2] || (_cache[2] = (e) => { _ctx.updateBindings({ services: e.detail.values.map((s) => s.replace(`${_ctx.namespace}/`, '')) }); }),
        onDropdownFilter: _cache[3] || (_cache[3] = (e) => { _unref(onServicesFilter)(e.detail.filter); })
      }, null, 40, _hoisted_4),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_unref(isErrorServices))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)(`epinio.services.errors.fetchAll`)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})